import { SimpleStateMachineUtil } from '@chesscom/web-ui';

const { createStateMachine } = SimpleStateMachineUtil;

interface Service<T> {
  send: <K extends keyof T>(type: K, value?: T[K]) => void;
  onTransition: (callback) => void;
}

export type MachineService<T> = SimpleStateMachineUtil.StateMachine.API & Service<T>;

/**
 * Extend hand pieces machine with event handlers and transition listeners
 */
export function createMachineService<T>(
  machineModel: SimpleStateMachineUtil.StateMachine.Config,
): MachineService<T> {
  const machine = createStateMachine(machineModel);
  /**
   * Send an action to the state machine
   */
  const send: Service<T>['send'] = (type, value) => {
    machine.transition(type as string, value);
    machine.emit('action', { type, value, nextState: machine.getCurrentState() });
  };

  const service = Object.assign({}, machine, {
    send,
    onTransition: (callback) => machine.on('action', callback),
  });

  return service;
}
